export const UKNOW_ERROR = { 'An error occurred': 'common.error' };

export const SIGNIN_RESPONSE_ERROR_MAPPING = {
    'User not found': 'signIn.errors.credentialsInvalid',
    'Email not verified': 'signIn.errors.notVerified',
    'Missing credentials': 'signIn.errors.credentialsMissing',
    'User does not belong to the required user type': 'signIn.errors.wrongAccountType',
    ...UKNOW_ERROR,
};

type SignInResponseError = keyof typeof SIGNIN_RESPONSE_ERROR_MAPPING;

const SIGNIN_STATUS_FALLBACK: Record<number, SignInResponseError> = {
    401: 'User not found',
    403: 'Email not verified',
};

// POST /v1/shared/users/login tells us what went wrong in the response body:
// { success, message } for the JSON failures and a bare string for the
// user-type mismatch. Turn that message into a translation key, and fall back
// to the status code when the body is empty or carries an unknown message.
export const resolveSignInError = (
    status: number,
    message?: string | null,
): string => {
    const responseError = message?.trim() as SignInResponseError | undefined;

    if (responseError && responseError in SIGNIN_RESPONSE_ERROR_MAPPING) {
        return SIGNIN_RESPONSE_ERROR_MAPPING[responseError];
    }

    return SIGNIN_RESPONSE_ERROR_MAPPING[
        SIGNIN_STATUS_FALLBACK[status] ?? 'An error occurred'
    ];
};
